module.exports = __webpack_public_path__ + "img/武汉理工.8246dcf6.png";